import {createContext,useState} from 'react';
import fr from './../data/fr.json';
import en from './../data/en.json';
import siteFr from './../translations/fr.json';
import leaderSkills from './../data/leaderSkills.json';

const AppContext = createContext();

const AppContextProvider = (props) => {
    const [language, setLanguage] = useState('en');
    const [collection, setCollection] = useState([]);
    const [collectionData,setCollectionData] = useState([]);
    
    const saveUserData = () => {
        localStorage.setItem("language",language)
        localStorage.setItem("collection",JSON.stringify(collection))
        localStorage.setItem("collectionData",JSON.stringify(collectionData))
    }
    const customStyle = {
        control: styles => ({ ...styles, backgroundColor: '#212932',color: 'white' }),
        placeholder: styles => ({ ...styles, backgroundColor: '#212932',color: 'white' }),
        singleValue: styles => ({ ...styles, backgroundColor: '#212932',color: 'white' }),
        groupType : (base,state) => ({
            ...base,
            backgroundColor: state.isSelected ? "#142f70" : state.isFocused ? "#142f70" : "#212932",
            color: 'white'  
        }),
        option: (base, state) => ({
          ...base,
          backgroundColor: state.isSelected ? "#142f70" : state.isFocused ? "#142f70" : "#212932",
          color: 'white'
        })  
    }
    const filterOptions = (candidate,input) => {
        if (input) {
            return candidate.data.text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        }
        return true;
    };
    const loadUserCollectionData = () => {
        let myCollectionData = JSON.parse(localStorage.getItem("collectionData"));
        if(!myCollectionData) {
            localStorage.setItem("collectionData",JSON.stringify(collectionData));
        } else {
            setCollectionData(myCollectionData);
        }
    }

    const loadUserData = () => {
        let myCollection = JSON.parse(localStorage.getItem("collection"));
        if(!myCollection) {
            localStorage.setItem("collection",JSON.stringify(collection));
        } else {
            setCollection(myCollection);
        }

        let myCollectionData = JSON.parse(localStorage.getItem("collectionData"));
        if(!myCollectionData) {
            localStorage.setItem("collectionData",JSON.stringify(collectionData));
        } else {
            setCollectionData(myCollectionData);
        }

        let temp = localStorage.getItem("language");
        if(temp != null) {
            const locals = temp
            if(!locals) {
                localStorage.setItem("language",language)   
            } else {
                setLanguage(locals);
            }
        } else {
            localStorage.setItem("language","en")   
            setLanguage("en");
        }
    }
    const saveCollection = (coll) => {

        let temp = coll.filter((e) => e.checked === true).map((e) => {
            return e.ID;
        })
        localStorage.setItem("collection",JSON.stringify(temp));
        setCollection(temp)
    }
    
    const findAwakeByHeroID = (id) => {
        let myCollectionData = collectionData.find((e) => e.heroID === id);
        if(myCollectionData === undefined) {
            return 0;
        }
        return myCollectionData.awake;
    }
    const findLevelByHeroID = (id) => {
        let myCollectionData = collectionData.find((e) => e.heroID === id);
        if(myCollectionData === undefined) {
            return 0;
        }
        return myCollectionData.level;
    }
    const findResonanceByHeroID = (id) => {
        let myCollectionData = collectionData.find((e) => e.heroID === id);
        if(myCollectionData === undefined) {
            return {"atk":0,"def":0,"hp":0};
        }
        return myCollectionData.resonance;
    }
    
    const _setCollectionData = (data) => {
        setCollectionData(data);
        localStorage.setItem("collectionData",JSON.stringify(collectionData))
    }

    const getLeaderSkillsDescription = (skillID,unit) => {
        let skill = leaderSkills.find((s) => s.LeaderSkill === unit.LeaderSkill);
        if(skill) {
            return searchKey(skill.Desc);
        } else {
            return "";
        }
    }
    const getLeaderSkillIcon = (skillID,unit) => {
        let skill = leaderSkills.find((s) => s.LeaderSkill === unit.LeaderSkill);
        if(skill) {
            return skill.SkillIcon;
        } else {
            return "";
        }
    }

    /**
     * It takes in a heroID, a type, and data, and then it updates the collectionData array with the
     * new data.
     * @param heroID - the ID of the hero you want to update
     * @param type - "awake", "level", "resonance"
     * @param data - the data that is being saved
     */
    const saveCollectionItemData = (heroID,type,data) => {
        let heroData = {};
        let tempCollectionData = [...collectionData];

        let isFind = false;
        tempCollectionData = tempCollectionData.map((e) => {
            let heroData = {...e};
            if(heroData.heroID === heroID) {
                isFind = true;
                switch(type) {
                    case "awake":
                        heroData.awake = data;
                        break;
                    case "level":
                        heroData.level = data;
                        break;
                    case "resonance":
                        heroData.resonance = data;
                    break;
                    default: 
                        break;
                }
            }
            return heroData;
        })
        if(!isFind) {
            heroData = {"heroID":heroID,"awake":0,"level":0,"resonance":{"atk":0,"def":0,"hp":0}};
            switch(type) {
                case "awake":
                    heroData.awake = data;
                    break;
                case "level":
                    heroData.level = data;
                    break;
                case "resonance":
                    heroData.resonance = data;
                break;
                default:
                    break;
            }
            tempCollectionData.push(heroData);
        }
        
        _setCollectionData(tempCollectionData);
        localStorage.setItem("collectionData",JSON.stringify(tempCollectionData));
    }
    
    const getCollectionItemData = (heroID) => {
        let temp = collectionData.find((e) => e.heroID === heroID);
        if(temp === undefined) {
            return {"heroID": heroID,"awake":0,"level":0,"resonance":{"atk":0,"pv": 0, "def": 0}};
        }
        return temp;
    }

    const changeLanguage = (lang) => {
        localStorage.setItem("language",lang)   
        setLanguage(lang);
    }
    const searchKey = (key) => {
        if(language === 'en') {
            let temp = en.find((i) => i.key === key);
            if(temp !== undefined){
                return en.find((i) => i.key === key).value;
            } else {
                //console.log("undefined key : "+key);
            }
                
        } else {
            let temp = fr.find((i) => i.key === key);
            if(temp !== undefined){
                return fr.find((i) => i.key === key).value;
            } else {
                //console.log("undefined key : "+key);
            }
        }
    }
    const translate = (key) => {
        if(language === "fr") {
            if(siteFr[key] !== undefined) {
                return siteFr[key];
            } else {
                console.log("key not found : "+key);
            }
        }
        return key;
    }
    return (
        <AppContext.Provider value={{getLeaderSkillsDescription,getLeaderSkillIcon,loadUserCollectionData,findAwakeByHeroID,getCollectionItemData,collectionData,saveCollectionItemData,findLevelByHeroID,findResonanceByHeroID,saveUserData,loadUserData,language,searchKey,customStyle,filterOptions,changeLanguage,translate,collection,setCollection,saveCollection}}>
            { props.children }
        </AppContext.Provider>
    )
}
export { AppContextProvider, AppContext }